import React from 'react';
import axios from "../../../containers/api";
import "../components/ManageUsers.css";
import {Colxx, Separator} from "../../../components/common/CustomBootstrap";
import {Badge, Button, Card, CardBody, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import {showCatchError} from "../../../helpers/Utils";
import EditUser from "../components/EditUser";
import {Table} from "../../../components/table/Table";

class ManageUser extends React.Component {
    state = {
        EditUserModal: false,
        agencyMembers: [],
        agency: {}
    };

    componentDidMount() {
        this.AgencyMembers();
    }

    AgencyMembers = () => {
        this.props.showSpinner();
        axios.get('api/ClientApi/GetAgencyMembers')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({agencyMembers: res.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    closeModal = (modalName) => {
        this.setState({ [modalName]: false });
        this.AgencyMembers();
    };

    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3>مدیریت کاربران</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column justify-content-center align-items-center">
                                <Table
                                    tableHeaders={[
                                        "نام کاربری",
                                        "نام و نام خانوادگی",
                                        "تلفن همراه",
                                        "وضعیت",
                                        "ویرایش",
                                    ]}

                                    tableRow={this.state.agencyMembers}

                                    tableData={[
                                        agencyMember => {
                                            return agencyMember.username;
                                        },
                                        agencyMember => {
                                            return agencyMember.fullname;
                                        },
                                        agencyMember => {
                                            return agencyMember.mobile;
                                        },
                                        agencyMember => {
                                            return (
                                                agencyMember.isActive === false ?
                                                    <Badge color="outline-danger" pill>غیر فعال</Badge>
                                                    :
                                                    <Badge color="outline-success" pill>فعال</Badge>
                                                )
                                        },
                                        agencyMember => {
                                            return (
                                                <Button outline color="info" className="btn-sm" onClick={() => this.setState({agency: agencyMember, EditUserModal: true})}>
                                                    ویرایش
                                                </Button>
                                            )
                                        }
                                    ]}
                                />
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                <Modal isOpen={this.state.EditUserModal} size="xlg" toggle={() => this.setState({EditUserModal: false})}>
                    <ModalHeader toggle={() => this.setState({EditUserModal: false})}>
                        ویرایش کاربر
                    </ModalHeader>
                    <ModalBody>
                        <EditUser
                            agency={this.state.agency}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({EditUserModal: false})}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>

            </>
        )

    }
}

export default ManageUser;